/*=========================================
	++ common.js ++ Ver.1.6.1
	Last update 2020.9.10
==========================================*/
/*
* 2020  9/10 全体を一新
* 2019  5/ 7  *object-fit-images 追加
* 2018 11/20  *ブラウザ判定処理を一新
* 2018 10/25  *jQuery 3系 に対応

*/

'usestrict';



//=====================================
//	Detecting Browser & Device Ver.1.4.2
//============================================

//++++++++++++ モバイル/タブレット/ブラウザ判定処理 ++++++++++++

//ブラウザ/デバイス 種別
var isMobile = false,
	isTablet = false,
	isRetina = false,
	isMobileTablet = false,
	isAndroid = false;

//モバイル　タブレット　判定
//https://w3g.jp/blog/js_browser_sniffing2015
var _ua = (function (u) {
	return {
		Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) ||
			u.indexOf("ipad") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
			u.indexOf("kindle") != -1 ||
			u.indexOf("silk") != -1 ||
			u.indexOf("playbook") != -1,
		Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
			u.indexOf("iphone") != -1 ||
			u.indexOf("ipod") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) |
			u.indexOf("blackberry") != -1
	};
})(window.navigator.userAgent.toLowerCase());

//モバイル
if (_ua.Mobile) {
	isMobile = true;
	isMobileTablet = true;
}
//タブレット
if (_ua.Tablet) {
	isTablet = true;
	isMobileTablet = true;
}

//Retina Display 判定
if (window.retina || window.devicePixelRatio > 1) {
	isRetina = true;
}

//Android 判定
if (/android[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
	isAndroid = true;
}




//============================================
//	デバイス　ブラウザ別の処理
//============================================

//++++++++++++ モバイル/タブレット クラス追加 ++++++++++++

$(function () {
	if (isMobile) {
		//HTMLにclass isMobileを追加
		$('html').addClass('isMobile');
		$('html').addClass('isMobileTablet');
	} else if (isTablet) {
		//HTMLにclass isTabletを追加
		$('html').addClass('isTablet');
		$('html').addClass('isMobileTablet');
	}
	//Retina Display isRetina クラス追加
	if (isRetina) {
		$('html').addClass('isRetina');
	}
});





//============================================
//	汎用スクリプト 
//============================================


//++++++ Copyright ++++++
// Copyright <span class="copyYear">&copy;</span>

$(function () {
	var date = new Date();
	var copyYear = date.getFullYear();
	copyYear = " 2001-" + copyYear;
	$('.copyYear').html(copyYear);
});




//============================================
//	アンカーリンク　スクロール
//============================================
$(function () {

	var TABLET_WIDTH = 768;
	//ウィンドウ幅
	var window_width = window.innerWidth;

	var nav_height = 120;
	if (window_width >= TABLET_WIDTH) {
		nav_height = 80;
	}


	var target_parm = '';
	var match = location.search.match(/target=(.*?)(&|$)/);
	if (match) {
		target_parm = decodeURIComponent(match[1]);
		target_parm = '#' + target_parm;
	}
	if (target_parm.length) {
		setTimeout(function () {
			var targetOffset = $(target_parm).offset().top - nav_height;
			$('html,body').animate({
				scrollTop: targetOffset
			}, 800);

			setTimeout(function () {
				var targetOffset_next = $(target_parm).offset().top - nav_height;
				$('html,body').animate({
					scrollTop: targetOffset_next
				}, 100);

			}, 800);
			console.log('@@' + targetOffset)
			return false;
		}, 800);

	}

});


function targetScroll() {

	var TABLET_WIDTH = 768;
	//ウィンドウ幅
	var window_width = window.innerWidth;

	var nav_height = 110;
	if (window_width >= TABLET_WIDTH) {
		nav_height = 80;
	}



	var target_parm = '';
	var match = location.search.match(/target=(.*?)(&|$)/);
	if (match) {
		target_parm = decodeURIComponent(match[1]);
		target_parm = '#' + target_parm;
	}
	if (target_parm.length) {
		setTimeout(function () {
			var targetOffset = $(target_parm).offset().top - nav_height;
			$('html,body').animate({
				scrollTop: targetOffset
			}, 800);
			console.log('@@' + targetOffset)
			return false;
		}, 800);

	}



}

//+++++++ 外部リンク判定 ++++++
$(function () {

	jQuery('a[href^=http]')
		.not('[href*="' + location.hostname + '"]')
		.attr({
			target: "_blank"
		})
		.addClass("outgoing");

	$('.mn_link a[href^=http]').each(function () {
		$(this).not('[href*="' + location.hostname + '"]').attr({
			target: "_blank"
		}).addClass("outgoing");

	})
});

//+++++++ Footer PageTOP ++++++

$(function () {

	$('.fixft_pagetop').on('click', function () {
		var targetOffset = $('Main').offset().top;
		//alert(targetOffset);
		$('html,body').animate({
			//scrollTop: targetOffset
			scrollTop: 0
		}, 800);
	});

});


// ++++++ 閉鎖メッセージ ++++++
$(document).ready(function () {

	/*
	if (!sessionStorage.getItem('popupClosed')) {
		$('#modal-info').show();
	}

	$('.js-close-info').on('click', function () {
		$('#modal-info').fadeOut();
		sessionStorage.setItem('popupClosed', 'true');
	});

	$(window).on('pageshow', function (event) {
		if (event.originalEvent.persisted || sessionStorage.getItem('popupClosed')) {
			$('#modal-info').hide();
		}
	});*/
});